/* @flow */

import * as React from 'react';

import {RelativeTimestampTimer} from './relative-timestamp-timer';
import {Timestamp} from './timestamp';
import type {RelativeTimestampFormat} from './types';

type Props = {
    datetime: ?number,
    format?: RelativeTimestampFormat,
    hideAgoString?: boolean,
    lowercase?: boolean,
    className?: string,
    customSuffix?: string,
};

export function RelativeTimestamp(props: Props) {
    const {className, ...rest} = props;

    return (
        <RelativeTimestampTimer {...rest}>
            {({formattedTimestamp}) => {
                return formattedTimestamp ? (
                    <Timestamp timestamp={formattedTimestamp} className={className} />
                ) : (
                    <div />
                );
            }}
        </RelativeTimestampTimer>
    );
}
